var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20.200001 20.200001",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 11.123437,15.953528 c -2.9687014,1.0025 -6.4242029,0.1583 -8.5734041,-2.5338 -2.22990092,-2.7929 -2.22630092,-6.8524003 0.0076,-9.6417015 2.9436015,-3.67570089 8.3269041,-3.89579969 11.5628041,-0.6604003 2.705,2.7051012 2.9947,6.9111018 0.8692,9.9376018 -0.459,0.6546 -0.3505,1.5525 0.2148,2.1183 l 4.1755,4.1755",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.931cbb4c5413670f5a468ca57d12a6b2.svg";
export { ForwardRef as ReactComponent };